import { UserImageType } from "@/schemas/user/image";
import type { UserProfile } from "@/schemas/user/profile";

export const TN531_USER_PROFILE: UserProfile = {
  username: "tn531",
  background: null,
  avatar: {
    id: "0",
    username: "tn531",
    likeCount: 0,
    type: UserImageType.AVATAR,
    attributes: {
      url: "https://dow-labs-dev.s3.us-east-1.amazonaws.com/kai-social-mocks/cherry/profile11.jpeg",
      previewUrl:
        "https://dow-labs-dev.s3.us-east-1.amazonaws.com/kai-social-mocks/cherry/profile11.jpeg",
      width: 0,
      height: 0,
    },
  },
  isFollowing: false,
  isBlocked: false,
  followerCount: 18,
  followingCount: 24,
  privatePhotoCount: 0,
  separation: null,
  publicImages: {
    total: 0,
    items: [],
    next: null,
  },
  location: {
    coordinates: {
      latitude: -122, // Latitude for Taipei City Hall Plaza
      longitude: 37, // Longitude for Taipei City Hall Plaza
    },
    address: {
      country: "United States",
      countryCode: "USA",
      street: "",
      city: "San Francisco",
      state: "California",
      stateCode: "CA",
      postalCode: "94107-1308",
      county: "San Francisco",
    },
  },
  attributes: {
    aboutMe: "Hello, looking to chat and meetup. #ENFJ #BJJ #Techie #Open",
    birthday: null,
    ethnicity: null,
    role: null,
    bodyType: null,
    relationship: null,
    seeking: [],
    languages: [],
    interests: [],
    weight: null,
    height: null,
    residence: null,
  },
  privatePhotoAccess: {
    status: null,
  },
  lastActivityTime: 0,
};

export const GREATK_USER_PROFILE: UserProfile = {
  username: "greatk",
  background: null,
  avatar: {
    id: "0",
    username: "greatk",
    likeCount: 0,
    type: UserImageType.AVATAR,
    attributes: {
      url: "https://dow-labs-dev.s3.us-east-1.amazonaws.com/kai-social-mocks/cherry/profile12.jpeg",
      previewUrl:
        "https://dow-labs-dev.s3.us-east-1.amazonaws.com/kai-social-mocks/cherry/profile12.jpeg",
      width: 0,
      height: 0,
    },
  },
  isFollowing: false,
  isBlocked: false,
  followerCount: 16,
  followingCount: 10,
  privatePhotoCount: 0,
  separation: null,
  publicImages: {
    total: 0,
    items: [],
    next: null,
  },
  location: {
    coordinates: {
      latitude: -122, // Latitude for Taipei City Hall Plaza
      longitude: 37, // Longitude for Taipei City Hall Plaza
    },
    address: {
      country: "United States",
      countryCode: "USA",
      street: "",
      city: "San Francisco",
      state: "California",
      stateCode: "CA",
      postalCode: "94107-1308",
      county: "San Francisco",
    },
  },
  attributes: {
    aboutMe: "Happy everyday! #happyday #foodie ",
    birthday: null,
    ethnicity: null,
    role: null,
    bodyType: null,
    relationship: null,
    seeking: [],
    languages: [],
    interests: [],
    weight: null,
    height: null,
    residence: null,
  },
  privatePhotoAccess: {
    status: null,
  },
  lastActivityTime: 0,
};

export const OBIY_USER_PROFILE: UserProfile = {
  username: "cherry",
  background: null,
  avatar: {
    id: "0",
    username: "obiy",
    likeCount: 0,
    type: UserImageType.AVATAR,
    attributes: {
      url: "https://dow-labs-dev.s3.us-east-1.amazonaws.com/kai-social-mocks/cherry/profile10.jpeg",
      previewUrl:
        "https://dow-labs-dev.s3.us-east-1.amazonaws.com/kai-social-mocks/cherry/profile10.jpeg",
      width: 0,
      height: 0,
    },
  },
  isFollowing: false,
  isBlocked: false,
  followerCount: 22,
  followingCount: 10,
  privatePhotoCount: 0,
  separation: null,
  publicImages: {
    total: 0,
    items: [],
    next: null,
  },
  location: {
    coordinates: {
      latitude: -122,
      longitude: 37,
    },
    address: {
      country: "United States",
      countryCode: "USA",
      street: "",
      city: "San Francisco",
      state: "California",
      stateCode: "CA",
      postalCode: "94107-1308",
      county: "San Francisco",
    },
  },
  attributes: {
    aboutMe: null,
    birthday: null,
    ethnicity: null,
    role: null,
    bodyType: null,
    relationship: null,
    seeking: [],
    languages: [],
    interests: [],
    weight: null,
    height: null,
    residence: null,
  },
  privatePhotoAccess: {
    status: null,
  },
  lastActivityTime: 0,
};
